/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 10:38:16
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


export default ({ label, list = [], color = [] }) => {
  return {
    title: {
      text: '公众认知主要关键词词频',
      textAlign: 'center',
      textStyle: {
        color: '#000',
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color,
    legend: {
      top: 30,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: label,
      axisLabel: { show: true, interval: 0, ...xAxisLabelColor },
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      axisLabel: { ...yAxisLabelColor },
    },
    series: list.map((item, index) => ({
      type: 'bar',
      name: item.title,
      data: index === 0 ? item.list : item.list.map(item => -item)
    }))
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P9/chart.js